import { StyledSVG } from '../../Atoms'
import { styled } from '../../Styles/stitches.config'

export const StyledCategoryButton = styled('button', {
    bgc: '$primary300',
    border: 'none',
    br: '$1',
    color: '$primary600',
    cursor: 'pointer',
    display: 'flex',
    p: '$2',
    placeContent: 'center',
    size: '100%',

    '&:hover': {
        backgroundColor: '$primary400',
        transition: '$default',
    },
    variants: {
        variant: {
            squaredButton: {
                [`& ${StyledSVG}`]: {
                    size: 40,
                },
            },
            oneLineButton: {
                justifyContent: 'space-between',

                [`& ${StyledSVG}`]: {
                    size: 20,
                },
            },
        },
    },

    defaultVariants: {
        variant: 'oneLineButton',
    },
})
